/*
 * @Author: zyy
 * @Date: 2022-10-08 11:13:44
 * @LastEditors: zyy
 * @LastEditTime: 2022-10-08 14:30:15
 * @Description: default
 */
import shopRequests from "../shopRequest";
import Qs from 'qs'
export default {
    // 积分商品列表
    list(params) {
        return shopRequests.get('/shop/admin_api_score/index', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 添加
    add(params) {
        return shopRequests.post('/shop/admin_api_score/add', params)
    },
    edit(params) {
        return shopRequests.post('/shop/admin_api_score/edit', params)
    },
    del(params){
        return shopRequests.post('/shop/admin_api_score/del', params)
    }

}